import { axiosClient } from "../api/axiosClient";

export interface SupplyPlanReadiness {
  horizonDays: number;
  summary: string;
  nextUp?: {
    type: "event" | "activity";
    id: string;
    name: string;
    date: string;
    daysUntil: number;
  };
  blockers: Array<{
    code: "shortfall" | "missing_cost";
    message: string;
    itemId?: string;
    eventId?: string;
    activityId?: string;
  }>;
}

export interface SupplyPlanMission {
  id: string;
  type:
    | "complete_costs"
    | "register_purchase"
    | "edit_item_cost"
    | "review_item"
    | "open_event"
    | "open_activity";
  label: string;
  itemId?: string;
  eventId?: string;
  activityId?: string;
  priority: number;
}

export interface SupplyPlanResponse {
  stock: {
    totalItems: number;
    totalUnits: number;
    lowStockCount: number;
    outOfStockCount: number;
  };
  items: Array<{
    id: string;
    name: string;
    category: string;
    unit: string;
    consumable: boolean;
    onHand: number;
    minimumQuantity: number;
    committedQuantity: number;
    reservedQuantity: number;
    toBuyQuantity: number;
    imageUrl?: string | null;
    unitCost?: number;
    costSource?: "purchase_history" | "manual" | null;
    unitCostMeta?: {
      outcomeId?: string;
      purchaseDate?: string;
      formattedPurchaseDate?: string;
    };
    estimatedCost?: number;
    sources: {
      activities: Array<{
        id: string;
        title: string;
        quantity: number;
        nextDate?: string;
      }>;
      events: Array<{
        id: string;
        name: string;
        quantity: number;
        nextDate?: string;
      }>;
    };
  }>;
  demand: {
    activityCount: number;
    eventCount: number;
    distinctItemCount: number;
  };
  costs?: {
    totalEstimatedCost: number;
    itemsWithCostCount: number;
    itemsWithoutCostCount: number;
    coveragePercent: number;
    formatted: {
      totalEstimatedCost: string;
    };
  };
  readiness: SupplyPlanReadiness;
  missions: SupplyPlanMission[];
}

export const supplyPlanRepository = {
  async getSupplyPlan(terreiroId?: string, mediumId?: string) {
    const params = terreiroId ? { terreiroId } : { mediumId };
    const { data } = await axiosClient.get<SupplyPlanResponse>(
      "/inventory-item/supply-plan",
      {
        params,
        withCredentials: true,
      },
    );
    return data;
  },
};
